import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import CopyIcon from '@mui/icons-material/FileCopyOutlined'
import { FormattedMessage, useIntl } from 'react-intl'
import ConfirmDialog from 'components/ConfirmDialog'
import Tooltip from '@mui/material/Tooltip'
import styles from './PostActions.pcss'
import Icon from '@mdi/react'
import { mdiArrowCollapseUp, mdiArrowCollapseDown } from '@mdi/js'

export interface PostedActionsProps {
  className?: string
  btnClassName?: string
  showMoveButtons: boolean | null
  classNameMid?: string
  classNameRight?: string
  onEdit: () => void
  onDelete?: () => void
  onCopy?: () => void
  onMoveToTop?: () => void
  onMoveToBottom?: () => void
  skipDeleteConfirm?: boolean // When true (undo available), delete fires without a confirm dialog
}

export function PostActions(props: PostedActionsProps) {
  const intl = useIntl()

  return (
    <div className={`${styles['actions-grid']} ${props.className || ''}`} data-testid="post-actions">
      <div className={styles.left}>
        <Tooltip title={<FormattedMessage id="post.actions.edit" />} placement="top">
          <IconButton
            key="edit"
            size="small"
            onClick={props.onEdit}
            className={`${styles['btn-action']} ${props.btnClassName || ''}`}
            data-action="edit"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {props.onCopy && (
          <Tooltip title={<FormattedMessage id="post.actions.copy" />} placement="top">
            <IconButton
              key="copy"
              size="small"
              className={`${styles['btn-action']} ${props.btnClassName || ''}`}
              data-action="copy"
              onClick={props.onCopy}
            >
              <CopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {props.onDelete && (
          <ConfirmDialog
            message={intl.formatMessage({ id: 'post.delete-confirm', defaultMessage: 'Delete post? This action cannot be undone.' })}
            variant="danger"
            disableConfirm={props.skipDeleteConfirm}
            confirmLabel={intl.formatMessage({ id: 'actions.delete' })}
          >
            {(confirm) => (
              <Tooltip title={<FormattedMessage id="post.actions.delete" />} placement="top">
                <IconButton
                  key="delete"
                  size="small"
                  data-btn-delete
                  data-action="delete"
                  className={`${styles['btn-action']} ${props.btnClassName || ''}`}
                  onClick={confirm(props.onDelete)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </ConfirmDialog>
        )}
      </div>
      <div className={`${styles.middle} ${!props.showMoveButtons ? styles.empty : ''} ${props.classNameMid || ''}`}></div>
      {props.showMoveButtons && (
        <div className={`${styles.right} ${props.classNameRight || ''}`}>
          <Tooltip title={<FormattedMessage id="post.actions.move-to-top" />} placement="top">
            <IconButton
              key="move-top"
              size="small"
              className={`${styles['btn-action']} ${props.btnClassName || ''}`}
              data-action="move-top"
              onClick={props.onMoveToTop}
            >
              <Icon size="20px" path={mdiArrowCollapseUp} />
            </IconButton>
          </Tooltip>
          <Tooltip title={<FormattedMessage id="post.actions.move-to-bottom" />} placement="top">
            <IconButton
              key="move-bottom"
              size="small"
              className={`${styles['btn-action']} ${props.btnClassName || ''}`}
              data-action="move-bottom"
              onClick={props.onMoveToBottom}
            >
              <Icon size="20px" path={mdiArrowCollapseDown} />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </div>
  )
}

export default PostActions
